import { Pipe, PipeTransform } from '@angular/core';
import { WordpressService } from '../wordpress.service';

@Pipe({
  name: 'label',
})
export class LabelPipe implements PipeTransform {

  constructor(private wordpressService: WordpressService) {
  }

  transform(value: any, ...args: any[]): any {

    const labels = this.wordpressService.getLabels();
    return (labels && labels[value]) || value;
  }
}
